import React, { Component } from "react";
export default class TncHdfc extends Component {
  render() {
    return (
      <div className="hdfc_page">
        <h5 className="icici_headings">Agent Agreement</h5>

        <h6 style={{ marginBottom: 20 }}>
          Please read the following terms and conditions of the agreement
          carefully. It contains very important information about your rights
          and obligations, as well as limitations and exclusions that may apply
          to you. This document contains a dispute resolution clause. By
          clicking on the “I AGREE” button, you are consenting to be bound by
          and are becoming a party to this agreement.{" "}
        </h6>

        <p>
          HDFC Pension Management Company Limited (“HDFC Pension”) and the
          person who is bound by the terms and conditions of their Agreement
          shall hereinafter collectively referred to as “Parties” and
          individually also as “Party”.{" "}
        </p>

        <h5>WHEREAS: </h5>

        <p style={{ margin: 10 }}>
          I. HDFC Pension has been granted a certificate of registration as a
          Point of Presence (POP) by the Pension Fund Regulatory and Development
          Authority (“Authority”) for providing various services as provided
          under applicable laws including but not limited to Pension Fund
          Regulatory and Development Authority (Point of Presence) Regulations
          2018.
        </p>
        <p style={{ margin: 10 }}>
          II. HDFC Pension is permitted to provide NPS services using either
          offline or online module or both and/or to assign the same to other
          entities, in accordance with and subject to the terms and conditions
          prescribed by Authority.
        </p>
        <p style={{ margin: 10 }}>
          {" "}
          III. The Agent has applied for registration as – a NPS Agent with HDFC
          Pension and acceptance of such registration as per the internal
          policies of HDFC Pension the Agent shall receive a registration number
          from HDFC Pension. The Agent agrees and is aware that the acceptance
          of the registration shall be at the sole discretion of HDFC Pension.
        </p>
        <p style={{ margin: 10 }}>
          IV. The obligations of parties under this Agreement shall only be
          invoked only post successful registration as an Agent with HDFC
          Pension.
        </p>
        <p style={{ margin: 10 }}>
          V. Agent has represented that they have adequate facilities/
          infrastructure, expertise and required experience of selling financial
          products, to provide NPS services in accordance with the HDFC
          Pensions’ requirements in compliance with rules, regulations,
          guidelines, directions, notifications, circulars, code of conduct and
          their amendments issued by HDFC Pension from time to time.
        </p>
        <p style={{ margin: 10 }}>
          VI. HDFC Pension has agreed to engage the Agent basis the
          representations provided by the Agent and on terms and conditions as
          mutually agreed under this Agreement.
        </p>
        <p>
          Now, therefore, in consideration of the mutual understanding as set
          forth in this Agreement the Parties hereto have agreed to the
          following terms and conditions:{" "}
        </p>

        <p>
          1.The Agent shall abide by all applicable laws and regulations
          including but not limited to the service standards provided under the
          regulations and guidelines issued by Authority in relation to National
          Pension System, for providing the functions relating to registration
          of subscribers and any other activity as prescribed / notified by the
          Authority and required under Prevention of Money Laundering Act (PMLA)
          2002.
        </p>

        <p>
          2.The Agent shall be provided access to HDFC Pensions portal
          (“Portal”) or through the Central Record-keeping Agency through which
          the Agent shall on board the customer. For online mode of customer on
          boarding, Agent shall be provided user credentials ;{" "}
        </p>
        <p style={{ margin: 15 }}>
          a. Where –Agent on boards customers using POP provided redirection
          model, the KYC verification shall be done by POP. In case NPS Agent
          wants to utilize existing verified KYC of its customers to on board
          for NPS with POP, NPS Agent shall provide relevant verified KYC
          documents to POP.
        </p>
        <p style={{ margin: 15 }}>
          b. Where – Agent on-boards customers using API based model, – Agent
          shall undertake Know Your Customer (KYC) verification process by
          utilising its own infrastructure for KYC verification process as per
          the regulation and guidelines of the Authority.{" "}
        </p>
        <p style={{ margin: 15 }}>
          c. Agent shall be solely liable/responsible to ensure the sanctity
          /correctness of the verification process
        </p>
        <p>
          3.This Agreement shall come into force on the Effective Date and shall
          remain valid unless this Agreement is terminated by the Parties
          pursuant to any provision of this Agreement.{" "}
        </p>
        <p>
          4.This Agreement may be terminated by either Party by giving 30 days’
          notice to other Party in writing. Neither party is required to give
          any reason for termination. However in case of breach of any terms and
          conditions of this Agreement, HDFC Pension may terminate this
          Agreement with immediate effect.
        </p>
        <p>
          5.This Agreement shall also stand terminated with immediate effect in
          the event, Authority cancels either the registration or refuses to
          renew the registration of the Agent.{" "}
        </p>
        <p style={{ padding: "10px 10px 10px 0px" }}>6.The Agent shall:</p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          a. Comply with the rules, regulations and guidelines issued by
          Authority in relation to National Pension System and relevant laws and
          guidelines issued by other statutory authorities;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          b. Abide by code of conduct and operational instructions/ directives
          issued by Authority from time to time and other laws in force;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          c. Keep and maintain the books and documents specified under rules,
          regulations and guidelines issued by Authority in relation to National
          Pension System;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          d. Comply with the Know Your Customer requirements specified or laid
          down by the Authority for National Pension System;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          e. Ensure the preservation and protection of the security and
          confidentiality with regard to all matters, documents, information or
          data already exchanged or to be exchanged in relation to any
          subscriber.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          f. Associate only with single POP.
        </p>

        <p style={{ padding: "10px 10px 10px 0px" }}>
          7.General Obligations: –Agent shall, subject to Clause 3 of this
          Agreement,
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          a. Provide subscriber registration form to customer for NPS
          subscription in online mode or both as per availability of
          infrastructure and case to case basis;
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          b. Receive subscriber registration form in Authority’s prescribed
          format duly filled and signed by the subscriber along with the
          necessary documentation;{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          c. Ensure that prescribed Know Your Customer documents have been
          attached with the Subscriber registration form.{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          d. Ensure that TATs pertaining to NPS account opening, Contribution
          processing or any Non financial transaction request from customers are
          adhered to as per applicable regulations and guidelines of the
          Authority.{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          e. Ensure that the subscriber registration form submitted by the
          applicant is complete in all respects;{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          f. Ensure that contribution is collected only by means of
          cheque/demand draft drawn in favour of "HDFC Pension Mgmt Co Ltd –
          Collection A/C – NPS - NPST". Collection of National Pension System
          contributions by way of cash is not permitted by Agent.{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          g. Ensure that Service Standards as provided in the agreement between
          the POP and National Pension System Trust and also provided in PFRDA
          and NPS Trust Regulations & circulars are adhered to.{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          h. Agent shall indemnify the customer and HDFC Pension from any
          liability, penalty, cost, compensation, order, demand, claim or any
          other liability arising due to breach of TAT or any applicable
          regulation by Agent with respect to services under NPS as prescribed
          by Authority and/or services provided under this Agreement including
          but not limited to KYC verification process.{" "}
        </p>

        <p style={{ margin: "10px 10px 10px 0px" }}>
          8.Agent shall not assign, delegate or transfer any rights, duties or
          obligations hereunder or interests herein without prior written
          consent of HDFC Pension and any attempted assignment shall be null and
          void.
        </p>

        <p style={{ margin: "10px 10px 10px 0px" }}>
          9.Agent agrees not to represent itself in any capacity other than
          providing NPS services as Agent with HDFC Pension. Further it shall
          not undertake any other activity for or on behalf of HDFC Pension
          during the existence of this Agreement and shall not act in any manner
          whatsoever for or on behalf of HDFC Pension after the expiry /
          termination of this Agreement unless expressly agreed by the Parties.
        </p>

        <p style={{ margin: "10px 10px 10px 0px" }}>
          10.Agent undertakes to ensure that its employees and Agents, if any,
          shall act in strict compliance with this Agreement and all applicable
          laws and shall ensure strict conformity to regulations, directions
          guidelines, notifications, circulars and code of conduct and their
          amendments from time to time issued by the Authority.
        </p>

        <p style={{ padding: "10px 10px 10px 0px" }}>
          11.Remuneration to Agent:
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          a. Subject to the provisions made by the Authority, the Parties agree
          that HDFC Pension shall pay the consideration to the – Agent for
          providing services agreed under the Agreement in accordance with the
          regulations and guidelines issued by Authority in relation to National
          Pension System.{" "}
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          b. All payments shall be subject to statutory deductions and other
          laws applicable from time to time. HDFC Pension may, basis mutual
          discussion, revise the fees, charges or deposits from time to time and
          the same will be applicable from the date mentioned in the
          communication received from HDFC Pension.
        </p>
        <p style={{ padding: "0px 0px 5px 25px " }}>
          c. In the event of any applicable charges, levied by POP’s vendor
          utilities including but not limited to Payment Gateway, KRA, CKYC, XML
          Aadhaar, the same shall be adjusted/set-off with the Remuneration
          payable to Agent.{" "}
        </p>
        <p>
          12. This Agreement constitutes the entire agreement between the
          Parties with respect to the subject matter hereof and supersedes all
          prior written agreements, understandings and negotiations, both
          written and oral, between the Parties with respect to the subject
          matter of this Agreement.
        </p>

        <p>
          13.1 The Agent shall use reasonable precautions, including but not
          limited to, physical, software, and network security measures, , to
          prevent anyone from monitoring, using, gaining access to or import of
          HDFC Pension’s information.{" "}
        </p>

        <p>
          13.2 The Agent shall initiate all measures which a prudent person,
          would take to secure and defend its systems that contain HDFC Life’s
          information against “hackers” and others who may seek, without
          authorisation, to modify or access its systems or HDFC Life’s
          information. The Agent will periodically test its systems for
          potential areas where security could be breached.
        </p>

        <p>
          13.3 The Agent shall take appropriate technical measures against (a)
          any unauthorised or unlawful processing or alteration of HDFC
          Pension’s information in the systems of the Agent, (b) any resultant
          loss or destruction of, or damage to, HDFC Pension’s information due
          to unauthorised processing or alterations, and (c) unauthorised or
          accidental access, processing, erasure, transfer, use, modification,
          or other misuse of HDFC Life’s information and shall ensure no third
          party shall have access Pension’s information.{" "}
        </p>

        <p>
          13.4The Agent shall be vigilant and to report any breach in the
          security practices, control processes and checks of the Agent and all
          suspected security events immediately to HDFC Pension’s Information
          Security Team at infosec@hdfclife.com.{" "}
        </p>

        <p>
          13.5 The Agent acknowledges and agrees that, in the course of its
          engagement by HDFC Pension, the Agent may receive or have access to
          personal information or sensitive personal data or information of HDFC
          Pensions customers. The Agent shall comply with the terms and
          conditions set forth in this Agreement and provisions under applicable
          law in its collection, receipt, transmission, storage, disposal, use
          and disclosure of such personal information or sensitive personal data
          or information and be responsible for the unauthorized collection,
          receipt, transmission, access, storage, disposal, use and disclosure
          of personal information or sensitive personal data or information
          under its control or in its possession.
        </p>

        <p>
          13.6 All personal information or sensitive personal data or
          information acquired by the Agent from HDFC Pension or its customers
          shall only be used for the purposes of this Agreement and shall not be
          further processed or disclosed without the prior written consent of
          HDFC Pension.
        </p>

        <p>
          13.7 Any information and data provided by the HDFC Pension or its
          customers to the Agent and used by the Agent directly or indirectly in
          the performance of this Agreement shall remain at all times the
          property of the HDFC Pension. It shall be identified, clearly marked
          and recorded as such by the Agent on all media and in all
          documentation
        </p>

        <p>
          14. The – Agent shall indemnify HDFC Pension and its officers,
          directors, employees, representatives, Agents, respective directors,
          and assigns from and against any liability, loss, damage, claims,
          settlement, cost, expenses and penalties of any kind levied on HDFC
          Pension caused due to the Agent including but not limited to the
          following (a) contravention of any applicable laws; (b) breach of the
          terms, conditions, covenants, representations, undertakings,
          obligations or warranties of this Agreement; and (c) non-compliance of
          the directions of the Authority. HDFC Pension reserves the right to
          withhold the payment due to – Agent to the extent of such unpaid loss/
          damage
        </p>
        <p>
          15. Agent agrees not to use the HDFC Pension’s name, logo, trademark,
          service marks or any other intellectual property right in any
          advertisement, publication, leaflet or document of any kind without
          obtaining prior written approval of HDFC Pension.
        </p>
        <p>
          16. All notices shall be in writing and sent by registered post or
          courier. If a notice is to be sent to the Agent by HDFC Pension then
          it shall be sent to the address available in the records of HDFC
          Pensions and if a notice is to be sent by the Agent to HDFC Pension
          then it shall be sent to the following address: Address: 14th Floor,
          Apollo Mills Compound, N.M. Joshi Marg, Mahalaxmi, Mumbai – 400011
        </p>
        <p>
          17. If the whole or any part of the performance by the Parties of
          their respective obligations hereunder is prevented or delayed by
          causes, circumstances or events beyond the control of the Parties
          including delays due to floods, fires, accidents, earthquakes, riots,
          explosions, wars, hostilities, acts of government, custom barriers, or
          other causes of like character, then to the extent the Parties are
          prevented or delayed from performing their obligations hereunder by
          reason thereof despite due diligence and reasonable efforts to do so
          notwithstanding such causes, circumstances or events, the Parties
          shall be excused from performance hereunder for so long as such
          causes, circumstances or events shall continue to prevent or delay
          such performance. The occurrence of a force majeure event shall be
          communicated immediately to the other Party
        </p>
        <p>
          18. This Agreement may be terminated by the Parties by giving 30 days’
          notice to other Party in writing. Neither party is required to give
          any reason for termination. However in case of breach of any terms and
          conditions of this Agreement, HDFC Pension shall terminate this
          Agreement with immediate effect
        </p>
        <p>
          19. If any provision of this Agreement is agreed by the Parties or
          held to be illegal, void or unenforceable under any law that is
          applicable hereto or if any court of competent jurisdiction in a final
          decision so determines, this Agreement shall continue to remain in
          force save that such provision shall be deemed to be deleted here from
          with effect from the date of such agreement or decision or such
          earlier date as the Parties may agree
        </p>
        <p>
          20. Any and all disputes or differences between the Parties arising
          out of or in connection with this Agreement or its performance shall,
          so far as it is possible, be settled amicably between the Parties. If
          after 30 (thirty) days of consultation, the Parties fail to reach an
          amicable settlement, any and all disputes or differences arising out
          of or in connection with this Agreement or its performance thereof,
          shall be referred to arbitration at the request of a Party upon
          written notice to that effect to the other Party and such arbitration
          shall be conducted in accordance with the Arbitration and Conciliation
          Act, 1996, as may be amended from time to time. A sole arbitrator
          shall be mutually appointed by the Parties. The Award of the
          Arbitrator shall be final and binding upon the Parties. The Seat of
          Arbitration shall be Mumbai only
        </p>
        <p>
          21. This Agreement shall be governed by the laws of India. For all
          purposes in relation to this Agreement, and specifically with regard
          to clause 21 relating to Arbitration, the Courts at Mumbai alone shall
          have exclusive jurisdiction. No other Court shall have jurisdiction to
          deal with any dispute or any matter between the Parties arising out of
          this Agreement.
        </p>
        <p>
          22. Revisions to this Agreement: HDFC Pension may at any time revise/
          amend the terms and conditions of this Agreement by updating it and
          providing notice to you of that change. Any changes to regulatory/
          statutory provisions shall automatically be deemed to incorporated
          into this Agreement without providing any notice and the terms and
          conditions in this Agreement shall stand modified to such extent.
        </p>
        <p>
          23. By checking/ clicking “I AGREE” the Agent hereby agrees to have
          read and understood the terms of this Service Level Agreement and be
          bound by same at all times. By checking/ clicking the “I AGREE” the
          Agent shall have deemed to have placed his signature on this document.
        </p>
      </div>
    );
  }
}
